import React from 'react';
import { BlackboardLogo } from './BlackboardLogo';

const LogoStacked = (props: React.HTMLAttributes<SVGElement>) => (
  <BlackboardLogo titleId="blackboard-logo-stacked" {...props} />
);

export default LogoStacked;
